import { showToasterMessage } from "@/store/actions/commonActions";
import { store } from "@/store";
import { checkAndGetCredentialsFromSession } from "@/utils/session";

export const handleCommonResponse = (instance) => {
    return instance.interceptors.response.use(
        (response) => response,
        (error) => {
            const { status, data } = error && error.response;
            if (status === 401) {
                store.dispatch(showToasterMessage(data[0], "error"));
            } else if (status === 500) {
                store.dispatch(showToasterMessage("Internal Server Error", "error"));
            }
            return Promise.reject(error);
        }
    );
};

export const handleCommonRequest = (instance, setHeaders = true) => {
    return instance.interceptors.request.use(
        (config) => {
            if (setHeaders) {
                let data = checkAndGetCredentialsFromSession();
                if (data && data.accessToken) {
                    config.headers = { Authorization: "Bearer " + data.accessToken };
                }
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );
};
